/**
 * Map pins for layers that are not migration routes.
 * Animal migrations use migration-routes.ts (paths + endpoints).
 */
export type MapLayerId = 'migrations' | 'inat';

export interface MapFeature {
  id: string;
  layer: MapLayerId;
  lat: number;
  lng: number;
  title: string;
  description: string;
}

/** Migration pins — empty; all panel species use route groups. */
export const MIGRATION_MAP_FEATURES: MapFeature[] = [];

/** Placeholder for future iNat observations on the map */
export const INAT_PLACEHOLDER_FEATURES: MapFeature[] = [];

export function getFeaturesForLayers(active: Set<MapLayerId>): MapFeature[] {
  const out: MapFeature[] = [];
  if (active.has('migrations')) out.push(...MIGRATION_MAP_FEATURES);
  if (active.has('inat')) out.push(...INAT_PLACEHOLDER_FEATURES);
  return out;
}
